import classNames from 'classnames';

import { NamesContainer } from 'pages/Workshop/Transactions/components/NamesContainer';
import { TransactionUserRoleMap } from 'settings/constants/transaction';
import {
  Options,
  DescriptionPopover,
  FilesPopover,
  TagsPopover,
  LinksPopover,
  EmailTemplatePopover,
  ChecklistsPopover,
} from './components';
import { Icons } from './../../Icons';

import styles from './styles.module.scss';

export const tasktableColumns = (
  handleEdit,
  handleRemove,
  handleView,
  isViewMode,
  isTransactionTasks = false,
) => [
  {
    title: 'Task',
    key: 'Name',
    dataIndex: 'Name',
    sorter: (a, b) => {
      if (a.Name < b.Name) return -1;
      if (a.Name > b.Name) return 1;
      return 0;
    },
    render: (value, task) =>
      isTransactionTasks ? (
        <strong className={styles.underlineClickable} onClick={() => handleEdit(task?.index)}>
          {value}
        </strong>
      ) : (
        <div
          className={classNames(styles.taskName, styles.underlineClickable)}
          onClick={() => handleView(task?.Id, task)}
        >
          <Icons variant={Icons.TASK} />
          <strong>{value}</strong>
        </div>
      ),
  },
  {
    title: 'Due Date',
    dataIndex: 'dueDate',
    key: 'dueDate',
    render: (_, task) => {
      const dueDate = `${task.Initial}${task.Operator}${task.DueDate}`;
      return <span>{dueDate}</span>;
    },
  },
  {
    title: 'Assigned To',
    dataIndex: 'AssigneeRoles',
    key: 'AssigneeRoles',
    render: (_, task) => {
      const taskRoles = task.AssigneeRoles?.map((i) => TransactionUserRoleMap[i] || i) || [];
      return <NamesContainer names={taskRoles} maxDisplayCount={2} />;
    },
  },
  {
    title: '',
    width: 500,
    key: 'options',
    render: (_, task) => {
      return (
        <div className={styles.tableOptions}>
          <DescriptionPopover description={task?.Description} />
          <ChecklistsPopover checklists={task?.Checklists} />
          <FilesPopover documents={task?.Documents} />
          <TagsPopover categories={task?.Categories} />
          <LinksPopover links={task?.Links} />
          <EmailTemplatePopover emailTemplate={task?.EmailTemplate} />
          <Options
            index={task?.index}
            editHandler={(index) =>
              isTransactionTasks ? handleEdit(index) : handleEdit(task?.Id, task)
            }
            removeHandler={(index) =>
              isTransactionTasks ? handleRemove(index) : handleRemove(task)
            }
            isViewMode={isViewMode}
          />
        </div>
      );
    },
  },
];
